<ng-container>
  {{ value }}
</ng-container>
